// extracted by mini-css-extract-plugin
module.exports = {"root":"DataViewHeaderAction_root","isDisabled":"DataViewHeaderAction_isDisabled"};